import { CompetitorPriceDTO } from '../../dto';

interface CompetitorPriceProps {
  storeNumber: number;
  url: string;
  price: number;
  lastObserved: string;
  previousPrice: number;
  previousLastObserved: string;
  unit: string;
  ownPrice: number;
  ownUnit: string;
  equivalentMgItemNumber: number;
  onDiscount: boolean;
}

export class CompetitorPrice {
  storeNumber: number;
  url: string;
  price: number;
  lastObserved: string;
  previousPrice: number;
  previousLastObserved: string;
  unit: string;
  ownPrice: number;
  ownUnit: string;
  equivalentMgItemNumber: number;
  onDiscount: boolean;

  constructor({
    storeNumber,
    url,
    price,
    lastObserved,
    previousPrice,
    previousLastObserved,
    unit,
    ownPrice,
    ownUnit,
    equivalentMgItemNumber,
    onDiscount,
  }: CompetitorPriceProps) {
    this.storeNumber = storeNumber;
    this.url = url;
    this.price = price;
    this.lastObserved = lastObserved;
    this.previousPrice = previousPrice;
    this.previousLastObserved = previousLastObserved;
    this.unit = unit;
    this.ownPrice = ownPrice;
    this.ownUnit = ownUnit;
    this.equivalentMgItemNumber = equivalentMgItemNumber;
    this.onDiscount = onDiscount;
  }

  static fromDto = (dto: CompetitorPriceDTO): CompetitorPrice =>
    new CompetitorPrice({
      storeNumber: dto.storeNumber,
      url: dto.url,
      price: dto.price,
      lastObserved: dto.lastObserved,
      previousPrice: dto.previousPrice,
      previousLastObserved: dto.previousLastObserved,
      unit: dto.unit,
      ownPrice: dto.ownPrice,
      ownUnit: dto.ownUnit,
      equivalentMgItemNumber: dto.equivalentMgItemNumber,
      onDiscount: dto.onDiscount,
    });
}
